<template>
  <div v-if="isShow()">
    <input v-model="fields.val" type="text" class="form-control" placeholder="Заголовок" @change="changeItem">
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref} from "vue"

export default defineComponent({
  name: "Title",
  components: {},
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)

    const fields = reactive({
      val: null,
    })

    onMounted(async () => {
      updateFields(props.payload)

      markUnshow()
      markShow()
    })

    function updateFields(query) {
      fields.val = query.val
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    function changeItem(e) {
      pushEvent(e.target.value)
    }

    function pushEvent(val) {
      emit("onChange", val)
    }

    return {
      isShow,
      fields,
      changeItem,
    }
  }
})
</script>

<style scoped src="./css/style.css">

</style>
